// Import Packages
import React from "react";
import { useTranslation } from "react-i18next";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';


function RemoveObjectFromGroup({
  action,
  variables,
  setOpenVariable,
  variableRender
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.";

  return (
    <div>
      <div className="form-element">
        <FieldLabel name={t(label + "MOVE-OBJECT.LDAP-PATH")} is_required={true} />
        <TextInput
          action={action}
          inputName="dn"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          fieldType="string"
          displayName={t(label + "MOVE-OBJECT.LDAP-PATH")}
          hideRequired={true}
        />
        <small className='conf-field-desc'>cn=test,cn=Users,dc=autommate,dc=com</small>
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "ADD-GROUP.GROUP-NAME")} is_required={true} />
        <TextInput
          action={action}
          isRequired={true}
          inputName="groupName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          fieldType="string"
          displayName={t(label + "ADD-GROUP.GROUP-NAME")}
          hideRequired={true}
        />
      </div>
    </div>
  );
}

export default RemoveObjectFromGroup;
